// src/utils/env.ts

type TEnvKey = keyof TImportMetaEnv;

/**
 * Hàm lấy biến môi trường:
 * Ưu tiên 1: Lấy từ window.RUNTIME_CONFIG (Runtime - Động sau khi build)
 * Ưu tiên 2: Fallback về import.meta.env (Build-time - Cố định khi vite build)
 */
export const getEnv = (key: TEnvKey): string => {
  if (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG[key] !== undefined) {
    return window.RUNTIME_CONFIG[key] ?? '';
  }
  return import.meta.env[key] || '';
};

export const ENV = new Proxy({} as TImportMetaEnv, {
  get(_, prop: string) {
    return getEnv(prop as keyof TImportMetaEnv);
  },
});
